<script>
import axios from 'axios';
import NewOptionDialog from './NewOptionDialog';

export default {
  name: 'RbxExtendedTextarea',
  components: {
    NewOptionDialog,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    propertyCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      text: this.value,
      id: `extTxAr${Math.ceil(Math.random() * 100000000)}`,
      isExtended: false,
      showNewOptionDialog: false,
      localPropertyCode: null,
    };
  },
  mounted() {
    this.localPropertyCode = this.propertyCode;
    this.show();
  },
  methods: {
    show() {
      axios.get(`/descriptionOption?propertyCode=${this.localPropertyCode}`)
        .then((descriptionOptions) => {
          if (descriptionOptions && descriptionOptions.data) {
          // let descriptionOptionTexts = descriptionOptions.data.map(function(it) {return it.name});
          //
          // this.options = descriptionOptionTexts;

            this.options = descriptionOptions.data;
          } else {
            this.option = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addText(name, text) {
      if (!this.text) this.text = '';

      const insert = text || name;
      const textarea = document.getElementById(this.id);
      const { selectionStart } = textarea;
      const firstChars = this.text.substring(0, selectionStart);
      const lastChars = this.text.substring(selectionStart, this.text.length);

      this.text = firstChars + (firstChars ? '\n' : '') + insert + lastChars;

      this.updateValue();
      textarea.focus();
    },
    deleteOption(id) {
      axios.delete(`/descriptionOption/${id}`)
        .then(() => {
          this.show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateValue() {
      this.$emit('input', this.text);
    },
  },
};
</script>

<template>
  <div class="rbx-extended-textarea">
    <v-textarea
      :id="id"
      ref="extTextarea"
      v-model="text"
      :label="label"
      class="caption"
      @click="isExtended = true"
      @input="updateValue"
    />
    <v-layout row wrap v-if="isExtended">
      <div v-for="option in options" :key="option.id">
        <v-btn
          small class="opt-btn" @click="addText(option.name, option.text)">{{ option.name }}</v-btn>
        <v-btn
          v-if="option.isCustom"
          class="del-btn"
          color="error"
          small
          @click="deleteOption(option.id)"
        >
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
      <v-btn
        small
        class="sve-btn"
        color="success"
        @click="showNewOptionDialog = true"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>

    <new-option-dialog
      v-if="showNewOptionDialog"
      :property-code="localPropertyCode"
      @cancel="showNewOptionDialog = false"
      @submit="show()"
    />
  </div>
</template>

<style lang="scss">
  button.del-btn {
    margin-right: 8px;
    margin-left: 0px;
    left: -5px;
    text-transform: none !important;
    min-width: 25px;
  }
  button.sve-btn {
    text-transform: none !important;
    min-width: 25px;
  }
  button.opt-btn {
    text-transform: none !important;
    font-weight: 400 !important;
    min-width: 25px;
  }
</style>
